import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]',
  standalone: false,
})
export class AutofocusDirective implements AfterContentInit {
  @Input() public appAutoFocus;
  @Input() public autoFocusTimeout = 500;

  public constructor(private el: ElementRef) {}

  public ngAfterContentInit() {
    if (this.appAutoFocus === '' || this.appAutoFocus === true) {
      setTimeout(() => {
        this.el.nativeElement.focus?.();
      }, this.autoFocusTimeout);
      // Get the nested input element on xi-input-field elements
    } else if (this.appAutoFocus === 'xiInput') {
      setTimeout(() => {
        this.el.nativeElement.querySelector('input')?.focus();
      }, this.autoFocusTimeout);
    } else if (this.appAutoFocus === 'xiTextArea') {
      setTimeout(() => {
        this.el.nativeElement.querySelector('textarea')?.focus();
      }, this.autoFocusTimeout);
    }
  }
}
